import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

// The editor sidebar's globe, scaled to the 20px glyph the other cards draw; the stroke is narrowed
// by the same factor so it renders at their 2.
export const IconGlobe = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 32 32"
    data-fill-none
  >
    <g
      transform="translate(16 16) scale(1.2) translate(-10 -10)"
      stroke="currentColor"
      strokeWidth="1.6667"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18.3333 10C18.3333 14.6024 14.6024 18.3333 10 18.3333C5.39763 18.3333 1.66667 14.6024 1.66667 10C1.66667 5.39763 5.39763 1.66667 10 1.66667C14.6024 1.66667 18.3333 5.39763 18.3333 10Z" />
      <path d="M1.66667 10H18.3333" />
      <path d="M10 1.66667C12.0844 3.94863 13.269 6.91003 13.3333 10C13.269 13.09 12.0844 16.0514 10 18.3333C7.9156 16.0514 6.73104 13.09 6.66667 10C6.73104 6.91003 7.9156 3.94863 10 1.66667Z" />
    </g>
  </SvgIcon>
));
IconGlobe.displayName = 'IconGlobe';
